import verificationModal from './verification-modal';

export default verificationModal;
